import { FC, Fragment } from 'react';
import { AnimationControls, motion } from 'framer-motion';
import { isEmpty } from 'radash';
import { IMenuList } from '@modules/header/domain/models/menu.model';
import CategoryMenuSkeleton from '@components/skeleton/categoryMenu/CategoryMenu';
import TabWithoutSlide from '@components/tab/default/TabWithoutSlide';
import { ITab } from '@shared/models/tab.model';
import { CategoryMenuType } from '@shared/types/categoryMenu.type';
import { buttonContainerVariants, menuContainerVariants, menuVariants } from '../subMenu/SubMenuMobile.animate';
import { ChildrenList, ChildrenListTitle, MenuListContainer } from '../subMenu/SubMenuMobile.style';
import { ButtonContainer, CustomButton, TabContainer } from './CategoryMenuMobile.style';
interface Props {
  tabs: ITab[];
  activeTab: CategoryMenuType;
  setActiveTab: (tabId: CategoryMenuType) => void;
  menuList: IMenuList[];
  onCloseMenu: () => void;
  animationControls: AnimationControls;
}
const CategoryMenuMobile: FC<Props> = ({
  tabs,
  activeTab,
  setActiveTab,
  menuList,
  onCloseMenu,
  animationControls
}: Props) => {
  return <motion.div animate={animationControls} variants={menuContainerVariants} initial="closed">
            <TabContainer animate={animationControls} variants={menuContainerVariants} initial="closed">
                <TabWithoutSlide items={tabs} activeKey={activeTab} setActiveKey={val => setActiveTab(val as CategoryMenuType)} />
            </TabContainer>
            <MenuListContainer animate={animationControls} variants={menuContainerVariants} initial="closed">
                {isEmpty(menuList) ? <Fragment>
                        <CategoryMenuSkeleton />
                        <CategoryMenuSkeleton />
                        <CategoryMenuSkeleton />
                        <CategoryMenuSkeleton />
                        <CategoryMenuSkeleton />
                    </Fragment> : menuList.map(menu => <ChildrenList key={menu.title} variants={menuVariants}>
                            <span>•</span>
                            <ChildrenListTitle $isActive={false} href={menu.linkOut} onClick={onCloseMenu}>
                                {menu.title}
                            </ChildrenListTitle>
                        </ChildrenList>)}
                <ButtonContainer variants={buttonContainerVariants}>
                    <CustomButton href={'/recipe'} onClick={onCloseMenu}>
                        ดูเมนูทั้งหมด
                    </CustomButton>
                </ButtonContainer>
            </MenuListContainer>
        </motion.div>;
};
export default CategoryMenuMobile;